import React from "react";
import { usePortalTheme, PortalThemeButton } from "@/components/PortalTheme";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { CompanyLogo } from "@/components/CompanyLogo";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export default function CustomerLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const { mode, toggle } = usePortalTheme();
  const doLogout = async () => { await logout(); nav("/login", { replace: true }); };

  return (
    <div className="min-h-screen" style={{ backgroundColor: mode === "night" ? "#202124" : "#ffffff" }}>
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6">
          <div className="flex items-center gap-4">
            <Brand />
            {user?.company_id && (
              <div className="hidden items-center gap-2 border-l border-slate-200 pl-4 sm:flex">
                <CompanyLogo companyId={user.company_id}
                  className="h-9 w-9 rounded-lg border border-slate-200 bg-white object-contain p-0.5" />
                {user?.company_name && (
                  <span className="text-sm font-semibold text-[#0a192f]">{user.company_name}</span>
                )}
              </div>
            )}
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-right sm:block">
              <span className="block text-sm font-semibold text-[#0a192f]">{user?.name}</span>
              <span className="block text-xs text-slate-500">Müşteri</span>
            </span>
            <PortalThemeButton mode={mode} toggle={toggle} />
            <Button variant="outline" size="sm" onClick={doLogout} data-testid="logout-button">
              <LogOut className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">Çıkış</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6"><Outlet /></main>
    </div>
  );
}
